import { render, staticRenderFns } from "./DiscoverSearch.vue?vue&type=template&id=69fe2ea2&"
import script from "./DiscoverSearch.vue?vue&type=script&lang=js&"
export * from "./DiscoverSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports